var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1340_8475)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16 32.1875C24.8366 32.1875 32 25.0241 32 16.1875C32 7.35094 24.8366 0.1875 16 0.1875C7.16344 0.1875 0 7.35094 0 16.1875C0 25.0241 7.16344 32.1875 16 32.1875Z",
    fill: "#F38600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8153 17.8428C20.0803 17.8428 19.3593 17.7278 18.6753 17.5028C18.3403 17.3878 17.9283 17.4928 17.7243 17.7028L16.3743 18.7218C14.8103 17.8858 13.8463 16.9218 13.0223 15.3698L14.0113 14.0558C14.2683 13.7988 14.3603 13.4238 14.2493 13.0728C14.0223 12.3858 13.9073 11.6648 13.9073 10.9298C13.9073 10.3988 13.4753 9.9668 12.9443 9.9668H10.7413C10.2103 9.9668 9.77832 10.3988 9.77832 10.9298C9.77832 17.0158 14.7283 21.9668 20.8153 21.9668C21.3453 21.9668 21.7783 21.5348 21.7783 21.0038V18.8058C21.7783 18.2758 21.3463 17.8428 20.8153 17.8428Z",
    fill: "#F38600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1340_8475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.1875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.f6feed30ba60c14078eb17aaad2f7229.svg";
export { ForwardRef as ReactComponent };